var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.className,attrs:{"id":'N'+_vm.x.toString()+'-'+_vm.y.toString()},on:{"mousedown":_vm.startBuilding,"mouseover":_vm.build,"click":function($event){return _vm.build(false)},"mouseup":_vm.stopBuilding}})}
var staticRenderFns = []

export { render, staticRenderFns }